import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {COMPETITION_CATEGORY, COMPETITION_FILTER} from "../../../core/app/consts";

export class CompetitionsRequestParams extends BaseApiRequestParams {
  sports: Array<Number>;
  competitions: Array<Number>;
  category: String;
  limit: Number;
  countries: Array<Number>;
  withSeasons: Boolean;
  withBestOdds: Boolean;
  featuredFilter: COMPETITION_FITER;

  constructor(
    sports: Array<Number> = [],
    competitions: Array<Number> = [],
    category: String = COMPETITION_CATEGORY.default,
    limit: Number = 10,
    countries: Array<Number> = [],
    withSeasons: Boolean = false,
    withBestOdds: Boolean = false,
    isDashboardRequest: Boolean = false,
    filter: String = COMPETITION_FILTER.default
  ) {
    super('competitions/' + (category ? `${category}/` : ''));

    this.sports = sports;
    this.competitions = competitions;
    this.limit = limit;
    this.countries = countries;
    this.withSeasons = withSeasons;
    this.withBestOdds = withBestOdds;
    this.isDashboardRequest = isDashboardRequest;
    this.featuredFilter = filter;
  }

  get competitionsParam() {
    return this.competitions?.length > 0 ? `&competitions=${this.competitions.toString()}` : '';
  }

  get sportsParam() {
    return this.sports && this.sports.length > 0 ? `&sports=${this.sports.toString()}` : '';
  }

  get limitParam() {
    return this.limit ? `&limit=${this.limit}` : '';
  }

  get countriesParam() {
    return this.countries && this.countries.length > 0 ? `&countries=${this.countries.toString()}` : '';
  }

  get withSeasonsParam() {
    return this.withSeasons ? `&withSeasons=${this.withSeasons}` : '';
  }

  get withBestOddsParam() {
    return this.withBestOdds ? `&withBestOdds=${this.withBestOdds}` : '';
  }

  get featuredFilterParam() {
    return this.featuredFilter ? `&type=${this.featuredFilter}` : '';
  }

  get isDashboardRequestParam() {
    return this.isDashboardRequest ? `&isDashboard=${this.isDashboardRequest}` : '';
  }

  toString(): string {
    return super.toString() + this.competitionsParam + this.sportsParam + this.limitParam + this.countriesParam + this.withSeasonsParam + this.withBestOddsParam + this.featuredFilterParam + this.isDashboardRequestParam;
  }

  equals(model: CompetitionsRequestParams): * {
    let equals = super.equals(model);

    equals &= this.competitionsParam === model.competitionsParam;
    equals &= this.sportsParam === model.sportsParam;
    equals &= this.limitParam === model.limitParam;
    equals &= this.countriesParam === model.countriesParam;
    equals &= this.withSeasonsParam === model.withSeasonsParam;
    equals &= this.withBestOddsParam === model.withBestOddsParam;
    equals &= this.featuredFilterParam === model.featuredFilterParam;
    equals &= this.isDashboardRequestParam === model.isDashboardRequestParam;

    return equals;
  }
}
